import Autosave from './autosave';
import ConsoleDebugger from './console-debugger';
import Keyboard from './keyboard';

export { Autosave, ConsoleDebugger, Keyboard };

export default {
  Autosave,
  Keyboard,
  ConsoleDebugger
};
